import React from 'react'
import { Button } from '@mui/material'
import { KeyboardBackspace } from '@mui/icons-material'
import { Img } from 'styles/GlobalStyle'
import { Go2 } from 'assets'

// עמוד פתיחה (עמוד 1)  
const Slide1Cover = ({ onStoryClick }) => (
    <div className='cover-layout'>
        <div className='cover-text'>
            <div className='cover-title'>{'הערכת הקריאה מתחברת לתמונה'}</div>
            <div>{'כאן אפשר להבין את מצב הקריאה,'}</div>
            <div>{'לעקוב אחרי התקדמות התלמידים'}</div>
            <div>{' ולקבל החלטות מדוייקות יותר.'}</div>
        </div>
        <Button className='cover-btn' onClick={onStoryClick} type='button'>
            <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <span>{'לסיפור של הנתונים'}</span>
                <KeyboardBackspace fontSize='small' />
            </span>
        </Button>
        <div className='cover-cartoon'>
            <Img src={Go2} alt='' />
        </div>
    </div>
)

export default Slide1Cover
